import { Action } from 'redux'

export enum types {
  DATA_POLLING__STARTED = 'DATA_POLLING__STARTED',
  DATA_POLLING__FAILURE = 'DATA_POLLING__FAILURE',
  DATA_POLLING__SUCCESS = 'DATA_POLLING__SUCCESS',
}

export type SuccessActionCreatorType = (...args: any[]) => Action<any>

export type FailureActionCreatorType = (
  message: string,
  correlationId: string,
  ...rest: any[]
) => Action<any>

export interface IDataPollingAction {
  type: types.DATA_POLLING__STARTED
  location: string
  startTime: number
  successAction: SuccessActionCreatorType
  failureAction: FailureActionCreatorType
  options?: any
}

// TODO: try to reuse the BE types
export enum PollingTaskStatus {
  Failed = 'Failed',
  Completed = 'Completed',
  Verified = 'Verified',
}

export interface IPollingTaskData {
  status: PollingTaskStatus
  errorDescription: string
  editionId?: string
  resource?: string
  correlationId: string
}

export interface ITask {
  location: string
}
